export default __webpack_public_path__ + "static/media/8425.e54fa698.jpg";